import { render, staticRenderFns } from "./RejectMnp.vue?vue&type=template&id=13cd9f98&"
import script from "./RejectMnp.vue?vue&type=script&lang=js&"
export * from "./RejectMnp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports